import { t } from "i18next"
import { z } from "zod"
import { deMedicationFragmentInline$data } from "@/modules/patients/detail/medication/de/services/__generated__/deMedicationFragmentInline.graphql"
import { dePrescriptionFragment$key } from "@/modules/patients/detail/prescription/de/services/__generated__/dePrescriptionFragment.graphql"

type PrescriptionDataType = {
  progressNoteId: string
  prescriptionRef?: dePrescriptionFragment$key
  id?: string
  medication?: deMedicationFragmentInline$data
}

const MAXIMUM_MEDICATIONS_PER_PRESCRIPTION = 3

const PrescriptionSchema = z.object({
  medicationIds: z
    .array(z.string())
    .min(1, {
      message: t("common.fieldErrorList.requiredField"),
    })
    .max(MAXIMUM_MEDICATIONS_PER_PRESCRIPTION, {
      message: t("patient.prescription.maxMedicationsCanBeAdded", { max: MAXIMUM_MEDICATIONS_PER_PRESCRIPTION }),
    }),
})

type Prescription = z.infer<typeof PrescriptionSchema>

export { PrescriptionSchema, type Prescription, type PrescriptionDataType, MAXIMUM_MEDICATIONS_PER_PRESCRIPTION }
